/*
 * @Author: 王枫叶
 * @Date: 2020-12-17 20:50:49
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-12-26 14:41:16
 */

import Main from '../views/main';
import audiobook from '../views/fiction/audiobook'
import novel from '../views/fiction/novel'
import report from '../views/fiction/report'
import audiobookCfg from '../views/fiction/audiobookCfg'
const fictionRouter = {

    path: '/fiction',
    component: Main,
    title: '小说管理',
    icon: 'el-icon-s-custom',
    meta: { keepAlive: true },
    children: [
      {
        path: '/novel',
        component:novel,
        name: 'novel',
        title: '小说列表',
        meta: { title: '小说列表'  ,keepAlive:true}
      },
      {
        path: '/audiobook',
        component:audiobook,
        name: 'audiobook',
        title: '有声小说',
        meta: { title: '有声小说'  ,keepAlive:true}
      },
      {
        path: '/report',
        component:report,
        name: 'report',
        title: '举报列表',
        meta: { title: '举报列表'  ,keepAlive:true}
      },
      {
        path: '/audiobookCfg',
        component:audiobookCfg,
        name: 'audiobookCfg',
        title: '折扣率配置',
        meta: { title: '折扣率配置'  ,keepAlive:true}
      }
    ]

}
export default fictionRouter
